import axios from "axios";

export const url = process.env.REACT_APP_REST_API_URL?.replace('/api/v1/', '/') || 'http://127.0.0.1:8000/'

export const apiUrl = process.env.REACT_APP_REST_API_URL || 'http://127.0.0.1:8000/api/v1/';

/**
 * Returns the bearer to attach to tenant API calls. Impersonation tabs have
 * `imp_access_token` in sessionStorage — they take precedence so a tab
 * running an active impersonation session never accidentally uses the
 * god-user's tenant token from localStorage (which would escape the
 * read-only middleware).
 *
 * sessionStorage is tab-isolated, so the god-user can keep a normal tenant
 * session in another tab without interference.
 */
export function getActiveBearerToken(): string | null {
    try {
        const imp = sessionStorage.getItem('imp_access_token');
        if (imp) return imp;
    } catch {
        // sessionStorage can throw on hardened browsers; fall through.
    }
    return localStorage.getItem('mikaBearerToken');
}

export function apiCaller<T>(method: string, url: any, data?: any, givenHeaders?: HeadersInit, isStringify?: boolean):Promise<T[] | null> {
    const token = getActiveBearerToken();
    return fetch(apiUrl + url, {
        method,
        headers: givenHeaders !== null ?
        {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        } : givenHeaders ,
        body: data ? (isStringify !== true ? JSON.stringify(data):data ) : null
    }).then(res => {
        if (res.ok) {
            return res.json();
        }
        return res.json().then((responseJson) => {
            throw (JSON.stringify(
                {
                    details: responseJson.errors,
                    status: res.status
                }
            ));
        })
    })
}

export function axiosCaller<T>(method: string, url: any, data?: any, givenHeaders?: object, isStringify?: boolean) {
    const token = getActiveBearerToken();
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
    if(method === "POST"){
        return axios.post(apiUrl + url, data,{headers}).then(res => {
            return res
        })
    }else if(method === "GET"){
        return axios.get(apiUrl + url,{headers}).then(res => {
            return res
        })
    }else if(method === "DELETE"){
        // axios.delete accepts a body via the `data` config field — useful for
        // destructive endpoints that take metadata alongside the deletion
        // (e.g. an audit-trail `note`). Existing callers pass undefined data,
        // which axios safely ignores, so this stays backward-compatible.
        return axios.delete(apiUrl + url, { headers, data }).then(res => {
            return res
        })
    }else if(method === "PATCH"){
        return axios.patch(apiUrl + url, data,{headers}).then(res => {
            return res
        })
    }else if(method === "PUT"){
        return axios.put(apiUrl + url, data,{headers}).then(res => {
            return res
        })
    }
}
